import type { KapitelDef } from './types.ts';

/**
 * Kundenauftrag (Prüfungsbereich 2a) – 36 % der Gesamtprüfung.
 *
 * Grundlage: § 11 ElekAusbV. Zugrunde gelegt wird das Errichten, Ändern oder
 * Instandhalten einer gebäudetechnischen Anlage mit situativem Fachgespräch.
 */
export const KUNDENAUFTRAG: KapitelDef[] = [
  {
    id: 'ka-auftraege',
    titel: 'Auftragsanalyse und Kundenkommunikation',
    bereich: 'kundenauftrag',
    position: '§ 11 Abs. 1 Nr. 1',
    gewicht: 3,
    atome: [
      { t: 'Kundenanforderung erfassen', l: 'Aus einem Kundengespräch die technische Anforderung herausarbeiten', f: 'wissen' },
      { t: 'Rückfragen sinnvoll stellen', l: 'Unklare Punkte gezielt hinterfragen statt annehmen', f: 'praxis' },
      { t: 'Technische Schnittstellen klären', l: 'Schnittstellen zu anderen Gewerken und zum Netzbetreiber benennen', f: 'praxis' },
      { t: 'Lösungsvarianten gegenüberstellen', l: 'Mindestens zwei technisch mögliche Lösungen gegenüberstellen', f: 'praxis' },
      { t: 'Kundenbegründung formulieren', l: 'Eine gewählte Variante betriebswirtschaftlich und ökologisch begründen', f: 'praxis' },
      { t: 'Kundenerwartung dokumentieren', l: 'Erwartungen des Kunden schriftlich festhalten', f: 'praxis' },
      { t: 'Arbeitsplatz für den Kunden einrichten', l: 'Arbeitsplatz einschließlich Sicherung und Zugang vorbereiten', f: 'praxis' },
      { t: 'Sachliche Kommunikation auf DE und EN', l: 'Technische Fachbegriffe in deutscher und englischer Sprache anwenden', f: 'wissen' },
    ],
  },
  {
    id: 'ka-planung',
    titel: 'Planung, Materialliste, Kalkulation und Termin',
    bereich: 'kundenauftrag',
    position: '§ 11 Abs. 1 Nr. 2',
    gewicht: 3,
    atome: [
      { t: 'Teilaufgaben festlegen', l: 'Einen Kundenauftrag in prüfbare Teilaufgaben zerlegen', f: 'praxis' },
      { t: 'Arbeitsablauf planen', l: 'Reihenfolge und Abhängigkeiten der Arbeiten bestimmen', f: 'praxis' },
      { t: 'Planungsunterlagen erstellen', l: 'Einen Ablaufplan erstellen, der der Dokumentation standhält', f: 'praxis' },
      { t: 'Materialbedarf ermitteln', l: 'Materialliste aus der Planung ableiten', f: 'praxis' },
      { t: 'Werkzeugbedarf ermitteln', l: 'Werkzeuge und Messgeräte für den Einsatz auswählen', f: 'praxis' },
      { t: 'Kosten kalkulieren', l: 'Material- und Arbeitsaufwand kalkulieren', f: 'rechnen', s: [2, 3, 4] },
      { t: 'Terminplanung und Abweichung', l: 'Termine verfolgen und bei Störung Prioritäten setzen', f: 'praxis' },
      { t: 'Planungsabweichung melden', l: 'Abweichungen von der Planung rechtzeitig melden', f: 'praxis' },
    ],
  },
  {
    id: 'ka-verlegung',
    titel: 'Werkzeuge, Befestigung und Leitungsverlegung',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 2 Nr. 10',
    gewicht: 2,
    atome: [
      { t: 'Leitungsarten unterscheiden', l: 'NYM-J, NYA-J, HNY und Koax für den Einsatzfall unterscheiden', f: 'wissen' },
      { t: 'Leitung auswählen', l: 'Leitungsart nach Verlegeart und Strombelastbarkeit wählen', f: 'norm' },
      { t: 'Leitung zurichten', l: 'Leitung mit den richtigen Werkzeugen schneiden und abisolieren', f: 'praxis' },
      { t: 'Anschlussarten herstellen', l: 'Schraub- und Steckverbindungen regelgerecht herstellen', f: 'praxis' },
      { t: 'Klemmen und Aderendhülsen', l: 'Aderendhülsen und Klemmen fachgerecht einsetzen', f: 'praxis' },
      { t: 'Befestigungsarten wählen', l: 'Dübel, Schrauben und Befestigungssysteme dem Untergrund anpassen', f: 'praxis' },
      { t: 'Untergrund prüfen', l: 'Eignung des Untergrunds für die Befestigung beurteilen', f: 'praxis' },
      { t: 'Leitungsweg festlegen', l: 'Leitungswege unter Beachtung der Auftragsvorgaben festlegen', f: 'praxis' },
      { t: 'Kennzeichnung anbringen', l: 'Leitungen und Stromkreise dauerhaft kennzeichnen', f: 'praxis' },
      { t: 'Elektromagnetische Verträglichkeit', l: 'Abstände zu Stör- und parallelschirmquellen einhalten', f: 'norm' },
    ],
  },
  {
    id: 'ka-verteilung',
    titel: 'Verteilerschrank, Stromkreise und Absicherung',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 2 Nr. 12',
    gewicht: 3,
    atome: [
      { t: 'Verteileraufbau lesen', l: 'Einen Verteilerplan lesen und die Belegung verstehen', f: 'praxis' },
      { t: 'SLS wählen', l: 'Schutzleiter-Sicherungsschalter nach Bemessungsstrom wählen', f: 'rechnen', s: [2, 3, 4] },
      { t: 'Leitungsschutzschalter wählen', l: 'Leitungsschutzschalter nach Kennlinie und Bemessungsstrom wählen', f: 'rechnen', s: [2, 3, 4] },
      { t: 'Absicherungswert festlegen', l: 'Absicherung so festlegen, dass die Leitung thermisch geschützt ist', f: 'rechnen', s: [2, 3, 4] },
      { t: 'Fehlerstromschutz einbauen', l: 'RCD nach erforderlichem Fehlerstrom auswählen und einbauen', f: 'norm' },
      { t: 'FI-Symbol im Stromlaufplan', l: 'FI in Stromlaufplänen sicher darstellen', f: 'praxis' },
      { t: 'Stromkreise beschriften', l: 'Stromkreise beschriften, z. B. nach Geräteort', f: 'praxis' },
      { t: 'Reserve im Verteiler', l: 'Freie Reserven und sinnvolle Reserve abschätzen', f: 'praxis' },
      { t: 'Klemmliste und Steigleitung', l: 'Klemmliste, Steigleitung und Etagenverteilung verbinden', f: 'praxis' },
      { t: 'Zähler und Sperrelement', l: 'Zähleranlage und Sperrelement regelgerecht montieren', f: 'praxis' },
    ],
  },
  {
    id: 'ka-plaene',
    titel: 'Installations-, Verdrahtungs- und Anschlusspläne',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 2 Nr. 1 lit. b, c, d',
    gewicht: 3,
    atome: [
      { t: 'Stromlaufplan lesen', l: 'Stromlaufpläne lesen und den Aufbau einer Anlage verstehen', f: 'praxis' },
      { t: 'Stromlaufplan zeichnen', l: 'Einen Stromlaufplan mit genormten Symbolen zeichnen', f: 'praxis' },
      { t: 'Übersichtsschaltplan anwenden', l: 'Übersichtsschaltpläne anwenden', f: 'praxis' },
      { t: 'Verdrahtungsplan anwenden', l: 'Verdrahtungspläne lesen und anwenden', f: 'praxis' },
      { t: 'Anordnungs- und Installationsplan', l: 'Gerätemontageorte und Leitungswege aus dem Plan ableiten', f: 'praxis' },
      { t: 'Anschlussplan anwenden', l: 'Anschlusspläne für Geräte lesen und umsetzen', f: 'praxis' },
      { t: 'Plan und Wirklichkeit abgleichen', l: 'Planungsunterlagen mit der örtlichen Gegebenheit vergleichen', f: 'praxis' },
      { t: 'Abgrenzung zu bauseitigen Leistungen', l: 'Gewerkeleistungen eindeutig voneinander abgrenzen', f: 'praxis' },
    ],
  },
  {
    id: 'ka-messen',
    titel: 'Messen und Messverfahren',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 2 Nr. 8',
    gewicht: 3,
    atome: [
      { t: 'Messgerät auswählen', l: 'Für den Messzweck das richtige Messgerät wählen', f: 'wissen' },
      { t: 'Durchgang prüfen', l: 'Durchgang einer Leitung feststellen', f: 'praxis' },
      { t: 'Kurzschluss feststellen', l: 'Kurzschluss zwischen Leiter und Schutzleiter feststellen', f: 'praxis' },
      { t: 'Isolationswiderstand messen', l: 'Isolationswiderstand messen und Grenzwert beurteilen', f: 'rechnen', s: [2, 3, 4] },
      { t: 'Erdschleifenwiderstand messen', l: 'Erdschleifenwiderstand messtechnisch bestimmen', f: 'praxis' },
      { t: 'Erdungswiderstand beurteilen', l: 'Erdungswiderstand gegen die Abschaltbedingung prüfen', f: 'rechnen', s: [2, 3, 4] },
      { t: 'Schleifenwiderstand messen', l: 'Schleifenwiderstand messen und Grenzwert prüfen', f: 'rechnen', s: [3, 4] },
      { t: 'Netz- und Anlagenzustand beurteilen', l: 'Netz- und Anlagenzustand messtechnisch beurteilen', f: 'praxis' },
    ],
  },
  {
    id: 'ka-pruefung',
    titel: 'Erst- und Wiederholungsprüfung, Prüfprotokoll',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 2 Nr. 6',
    gewicht: 3,
    atome: [
      { t: 'Prüfumfang festlegen', l: 'Prüfumfang einer Erst- und Wiederholungsprüfung bestimmen', f: 'norm' },
      { t: 'Sichtprüfung', l: 'Anlage sichtprüfen und Mängel erkennen', f: 'praxis' },
      { t: 'Funktionsprüfung', l: 'Funktion der Schutzmaßnahmen prüfen', f: 'praxis' },
      { t: 'Erdungsmessung', l: 'Erdungsmessung durchführen und protokollieren', f: 'praxis' },
      { t: 'Fehlersuche an der Anlage', l: 'Fehler systematisch eingrenzen und beheben', f: 'praxis' },
      { t: 'Dokumentation der Prüfung', l: 'Prüfergebnis vollständig dokumentieren', f: 'praxis' },
      { t: 'Prüfprotokoll erstellen', l: 'Ein vollständiges Prüfprotokoll ausfüllen', f: 'praxis' },
      { t: 'Prüfintervalle benennen', l: 'Prüfintervalle für Anlagen und Betriebsmittel benennen', f: 'norm' },
      { t: 'Prüfung nach Norm dokumentieren', l: 'Nachweis der Prüfung normgerecht führen', f: 'norm' },
      { t: 'Prüfgerät einsetzen', l: 'Netz- und Erdungsmessgerät fachgerecht einsetzen', f: 'praxis' },
    ],
  },
  {
    id: 'ka-inbetriebnahme',
    titel: 'Inbetriebnahme, Fehlersuche, Abnahme und Übergabe',
    bereich: 'kundenauftrag',
    position: '§ 11 Abs. 1 Nr. 3 und 4',
    gewicht: 3,
    atome: [
      { t: 'Inbetriebnahme schrittweise', l: 'Anlage schrittweise in Betrieb nehmen', f: 'praxis' },
      { t: 'Funktionskontrolle', l: 'Jeden Stromkreis auf Funktion prüfen', f: 'praxis' },
      { t: 'Betriebswerte einstellen', l: 'Betriebswerte einstellen und dokumentieren', f: 'praxis' },
      { t: 'Fehler systematisch suchen', l: 'Fehler planmäßig eingrenzen, verursachen und beseitigen', f: 'praxis' },
      { t: 'Schutzmaßnahmen prüfen', l: 'Schutzmaßnahmen im fertigen Zustand prüfen', f: 'norm' },
      { t: 'Abnahmeprotokoll erstellen', l: 'Abnahmeprotokoll erstellen und beiderlei Seiten bestätigen', f: 'praxis' },
      { t: 'Kunde einweisen', l: 'Kunden in die Bedienung einweisen', f: 'praxis' },
      { t: 'Gefahren aufzeigen', l: 'Auf Gefahren der Anlage hinweisen und Änderungen beraten', f: 'praxis' },
      { t: 'Übergabe der Anlage', l: 'Anlage und Unterlagen vollständig übergeben', f: 'praxis' },
    ],
  },
  {
    id: 'ka-gebaeudetechnik',
    titel: 'Gebäudetechnik: Wärmepumpe, PV, Wallbox, Beleuchtung',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 3 Nr. 2 und 3',
    gewicht: 3,
    atome: [
      { t: 'Wärmepumpe anschließen', l: 'Wärmepumpe elektrisch anschließen und parametrieren', f: 'praxis' },
      { t: 'Wärmepumpe dimensionieren', l: 'Wärmepumpenleistung abschätzen und bewerten', f: 'rechnen', s: [2, 3, 4] },
      { t: 'Leistungszahl und JAZ', l: 'COP und JAZ berechnen und einordnen', f: 'rechnen', s: [2, 3, 4] },
      { t: 'Photovoltaik-Strang auslegen', l: 'Strangspannung und Strangstrom einer PV-Anlage bestimmen', f: 'rechnen', s: [3, 4] },
      { t: 'PV-Anlage elektrisch', l: 'PV-Anlage mit Wechselrichter und Zählerwechsel elektrisch realisieren', f: 'praxis' },
      { t: 'Überspannungsschutz installieren', l: 'Überspannungsschutz in die DC- und AC-Seite einbauen', f: 'praxis' },
      { t: 'Einspeisung und Zählerwechsel', l: 'Einspeisung, Anmeldung und Zählerwechsel unterscheiden', f: 'norm' },
      { t: 'Wallbox anschließen', l: 'Wallbox anschließen und Absicherung festlegen', f: 'praxis' },
      { t: 'Lastmanagement', l: 'Lastmanagement bei gleichzeitiger Nutzung mehrerer Verbraucher', f: 'norm' },
      { t: 'Beleuchtungsanlage montieren', l: 'Beleuchtungsanlage montieren und in Betrieb nehmen', f: 'praxis' },
      { t: 'Notstrom und Sicherheitsbeleuchtung', l: 'Notstrom und Sicherheitsbeleuchtung unterscheiden und prüfen', f: 'norm' },
      { t: 'Energieeffizienz', l: 'Maßnahmen zur Energieeffizienz im Gebäudebereich benennen', f: 'wissen' },
    ],
  },
  {
    id: 'ka-gebäudesystemtechnik'.normalize('NFD').replace(/[\u0300-\u036f]/g, 'ae'),
    titel: 'Gebäudesystemtechnik: KNX, Sensoren und Aktoren',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 3 Nr. 4',
    gewicht: 2,
    atome: [
      { t: 'Bus und Instanz', l: 'Bussystem, Teilnehmer und Instanzen unterscheiden', f: 'wissen' },
      { t: 'Aktoren verdrahten', l: 'Aktoren im Busch verdrahten und parametrieren', f: 'praxis' },
      { t: 'Präsenzmelder einbauen', l: 'Präsenz- und Bewegungsmelder einbauen und einstellen', f: 'praxis' },
      { t: 'Jalousie ansteuern', l: 'Jalousie- und Rollladenaktoren ansteuern', f: 'praxis' },
      { t: 'Zeitschaltlogik', l: 'Zeitschaltungen und Szenen parametrieren', f: 'praxis' },
      { t: 'Gebäudesystem in Bestandsanlage', l: 'Gebäudesystem in eine Bestandsanlage integrieren', f: 'praxis' },
      { t: 'Datenschutz in der Gebäudetechnik', l: 'Datenschutz und Informationssicherheit berücksichtigen', f: 'norm' },
      { t: 'Fernzugriff absichern', l: 'Fernzugriff und Netzanbindung sicher konfigurieren', f: 'norm' },
    ],
  },
  {
    id: 'ka-antenne',
    titel: 'Antennen- und Breitbandkommunikation',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 3 Nr. 5',
    gewicht: 1,
    atome: [
      { t: 'Antennenanlage aufbauen', l: 'Aufbau einer SAT- und terrestrischen Antennenanlage erklären', f: 'wissen' },
      { t: 'Antennenanlage messen', l: 'Antennenanlage messen und beurteilen', f: 'praxis' },
      { t: 'Koaxiale Verlegung', l: 'Koaxleitung fachgerecht verlegen und verschrauben', f: 'praxis' },
      { t: 'Breitbandverteilung', l: 'Breitbandverteilung im Gebäude aufbauen', f: 'praxis' },
    ],
  },
  {
    id: 'ka-sicherheit',
    titel: 'Sicherheit und Gesundheitsschutz bei der Arbeit',
    bereich: 'kundenauftrag',
    // § 11 Abs. 1 Nr. 5 verlangt Sicherheit und Gesundheitsschutz bei der
    // Arbeit ausdrücklich als Teil des Kundenauftrags – die Stelle fehlte hier.
    position: '§ 4 Abs. 2 Nr. 6, § 4 Abs. 3 Nr. 1, § 11 Abs. 1 Nr. 5',
    gewicht: 2,
    atome: [
      { t: 'Sicherheitsregeln anwenden', l: 'Sicherheitsregeln beim Arbeiten an elektrischen Anlagen anwenden', f: 'norm' },
      { t: 'Freischalten und Sperren', l: 'Anlage freischalten, gegen Wiedereinschalten sichern und prüfen', f: 'praxis' },
      { t: 'Arbeitsschutzvorschriften', l: 'Arbeitsschutz- und Unfallverhütungsvorschriften anwenden', f: 'norm' },
      { t: 'Persönliche Schutzausrüstung', l: 'Persönliche Schutzausrüstung auswählen und benutzen', f: 'praxis' },
      { t: 'Not-Aus und Brandschutz', l: 'Not-Aus-Einrichtungen und Brandschutzmaßnahmen prüfen', f: 'norm' },
    ],
  },
  {
    id: 'ka-dokumentation',
    titel: 'Dokumentation und Berichtswesen',
    bereich: 'kundenauftrag',
    position: '§ 4 Abs. 2 Nr. 1, § 11 Abs. 1 Nr. 4',
    gewicht: 2,
    atome: [
      { t: 'Arbeitsbericht schreiben', l: 'Arbeitsbericht nachvollziehbar und fachlich korrekt verfassen', f: 'praxis' },
      { t: 'Geräte- und Systemdaten', l: 'Geräte- und Systemdaten vollständig dokumentieren', f: 'praxis' },
      { t: 'Normtexte anwenden', l: 'Technische Regelwerke und Normen anwenden', f: 'norm' },
      { t: 'Englische Fachbegriffe', l: 'Englische Fachbegriffe in Angebots- und Dokumentationstexten anwenden', f: 'wissen' },
      { t: 'Daten sichern und archivieren', l: 'Projektdaten sichern, pflegen und archivieren', f: 'praxis' },
      { t: 'Qualität der Arbeitsergebnisse prüfen', l: 'Arbeitsergebnisse kontrollieren und bewerten', f: 'praxis' },
    ],
  },
];
